
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AutomatedSearchResponse,
  SourcingSearchByIdentifierRequest,
  SourcingSearchCodeWithLabel,
  SourcingSearchFilters,
  SourcingSearchRequest,
  SourcingSearchResponse,
  ValidationError,
} from '../models';
import {
    AutomatedSearchResponseFromJSON,
    AutomatedSearchResponseToJSON,
    SourcingSearchByIdentifierRequestFromJSON,
    SourcingSearchByIdentifierRequestToJSON,
    SourcingSearchCodeWithLabelFromJSON,
    SourcingSearchCodeWithLabelToJSON,
    SourcingSearchFiltersFromJSON,
    SourcingSearchFiltersToJSON,
    SourcingSearchRequestFromJSON,
    SourcingSearchRequestToJSON,
    SourcingSearchResponseFromJSON,
    SourcingSearchResponseToJSON,
    ValidationErrorFromJSON,
    ValidationErrorToJSON,
} from '../models';

export interface GetAutomatedSearchRequest {
    briefId: string;
}

export interface GetSourcingSearchFiltersRequest {
    briefId: string;
}

export interface SourcingSearchOperationRequest {
    sourcingSearchRequest: SourcingSearchRequest;
}

export interface SourcingSearchByIdentifierOperationRequest {
    sourcingSearchByIdentifierRequest: SourcingSearchByIdentifierRequest;
}

export interface SourcingSearchUnregisteredRequest {
    sourcingSearchRequest: SourcingSearchRequest;
}

/**
 * 
 */
export class SourcingSearchApi extends runtime.BaseAPI {

    /**
     * Fallback URL @malt/sse refetches on connect, always pending as no result is stored
          */
    async getAutomatedSearchRaw(requestParameters: GetAutomatedSearchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AutomatedSearchResponse>> {
        if (requestParameters['briefId'] == null) {
            throw new runtime.RequiredError(
                'briefId',
                'Required parameter "briefId" was null or undefined when calling getAutomatedSearch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AutomatedSearchResponse>({
            path: `/search/api/sourcing/{briefId}/automated-search`.replace(`{${"briefId"}}`, encodeURIComponent(String(requestParameters['briefId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AutomatedSearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Fallback URL @malt/sse refetches on connect, always pending as no result is stored
          */
    async getAutomatedSearch(requestParameters: GetAutomatedSearchRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AutomatedSearchResponse> {
        const response = await this.getAutomatedSearchRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get the sourcing search filters prefilled from a brief
          */
    async getSourcingSearchFiltersRaw(requestParameters: GetSourcingSearchFiltersRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SourcingSearchFilters>> {
        if (requestParameters['briefId'] == null) {
            throw new runtime.RequiredError(
                'briefId',
                'Required parameter "briefId" was null or undefined when calling getSourcingSearchFilters().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<SourcingSearchFilters>({
            path: `/search/api/sourcing/{briefId}/filters`.replace(`{${"briefId"}}`, encodeURIComponent(String(requestParameters['briefId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=SourcingSearchFiltersFromJSON(response._data); }
        return response;
    }

    /**
     * Get the sourcing search filters prefilled from a brief
          */
    async getSourcingSearchFilters(requestParameters: GetSourcingSearchFiltersRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SourcingSearchFilters> {
        const response = await this.getSourcingSearchFiltersRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get all available functional skills for the Supply Explorer
          */
    async getSourcingSearchFunctionalSkillsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<SourcingSearchCodeWithLabel>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<SourcingSearchCodeWithLabel>>({
            path: `/search/api/sourcing/ontology/functional-skills`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(SourcingSearchCodeWithLabelFromJSON);
        return response;
    }

    /**
     * Get all available functional skills for the Supply Explorer
          */
    async getSourcingSearchFunctionalSkills(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<SourcingSearchCodeWithLabel>> {
        const response = await this.getSourcingSearchFunctionalSkillsRaw(initOverrides);
        return response._data;
    }

    /**
     * Search freelancers in the Supply Explorer
          */
    async sourcingSearchRaw(requestParameters: SourcingSearchOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SourcingSearchResponse>> {
        if (requestParameters['sourcingSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'sourcingSearchRequest',
                'Required parameter "sourcingSearchRequest" was null or undefined when calling sourcingSearch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SourcingSearchResponse>({
            path: `/search/api/sourcing/manual`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SourcingSearchRequestToJSON(requestParameters['sourcingSearchRequest']),
        }, initOverrides);

        if (response._data) { response._data=SourcingSearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Search freelancers in the Supply Explorer
          */
    async sourcingSearch(requestParameters: SourcingSearchOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SourcingSearchResponse> {
        const response = await this.sourcingSearchRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Search a freelancer by name, profile URL, or account URL in the Supply Explorer
          */
    async sourcingSearchByIdentifierRaw(requestParameters: SourcingSearchByIdentifierOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SourcingSearchResponse>> {
        if (requestParameters['sourcingSearchByIdentifierRequest'] == null) {
            throw new runtime.RequiredError(
                'sourcingSearchByIdentifierRequest',
                'Required parameter "sourcingSearchByIdentifierRequest" was null or undefined when calling sourcingSearchByIdentifier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SourcingSearchResponse>({
            path: `/search/api/sourcing/identifier`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SourcingSearchByIdentifierRequestToJSON(requestParameters['sourcingSearchByIdentifierRequest']),
        }, initOverrides);

        if (response._data) { response._data=SourcingSearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Search a freelancer by name, profile URL, or account URL in the Supply Explorer
          */
    async sourcingSearchByIdentifier(requestParameters: SourcingSearchByIdentifierOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SourcingSearchResponse> {
        const response = await this.sourcingSearchByIdentifierRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Search unregistered freelancers
          */
    async sourcingSearchUnregisteredRaw(requestParameters: SourcingSearchUnregisteredRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SourcingSearchResponse>> {
        if (requestParameters['sourcingSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'sourcingSearchRequest',
                'Required parameter "sourcingSearchRequest" was null or undefined when calling sourcingSearchUnregistered().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SourcingSearchResponse>({
            path: `/search/api/sourcing/unregistered`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SourcingSearchRequestToJSON(requestParameters['sourcingSearchRequest']),
        }, initOverrides);

        if (response._data) { response._data=SourcingSearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Search unregistered freelancers
          */
    async sourcingSearchUnregistered(requestParameters: SourcingSearchUnregisteredRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SourcingSearchResponse> {
        const response = await this.sourcingSearchUnregisteredRaw(requestParameters, initOverrides);
        return response._data;
    }

}
